import { AvatarSize, useModal } from '@pelando/components';
import { useTranslation } from '@/presentation/hooks/useTranslation';
import { mediumScreenModalStyle } from '../../styles/shared/modal';
import { ModalAvatar, ModalButton, ModalContainer, ModalTitle } from './style';

type UnfollowModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
  avatar?: string;
  nickname: string;
};

function UnfollowModal({
  onConfirm,
  onCancel,
  avatar,
  nickname,
}: UnfollowModalProps) {
  const { t } = useTranslation('profile');
  return (
    <ModalContainer>
      <ModalAvatar size={AvatarSize.PROFILE} src={avatar} />
      <ModalTitle>{`${t('unfollow-modal-title')}${nickname}`}</ModalTitle>
      <ModalButton light onClick={onConfirm} data-testid="unfollow">
        {t('unfollow-modal-button')}
      </ModalButton>
      <ModalButton onClick={onCancel} data-testid="cancel">
        {t('unfollow-modal-button-cancel')}
      </ModalButton>
    </ModalContainer>
  );
}

type ShowUnfollowModalParams = Pick<
  UnfollowModalProps,
  'onConfirm' | 'avatar' | 'nickname'
>;

export const useShowUnfollowModal = () => {
  const { showModal, closeModal } = useModal();

  const showUnfollowModal = ({
    onConfirm,
    nickname,
    avatar,
  }: ShowUnfollowModalParams) =>
    showModal(
      <UnfollowModal
        onConfirm={() => {
          onConfirm();
        }}
        onCancel={() => closeModal()}
        avatar={avatar}
        nickname={nickname}
      />,
      { style: mediumScreenModalStyle }
    );

  return {
    showUnfollowModal,
  };
};

export default UnfollowModal;
